

































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import AccordionSelect from '@/components/AccordionSelect.vue'
import { ISelectItem } from '@/interfaces/Select'
import { ECollectionFlowActions, ETemplateType, ITemplate } from '@zunta/configurations'
import InputV2 from '@/components/inputsV2/InputV2.vue'

interface IFlowItem {
  template: number | null;
}

@Component({
  name: 'FlowItem',
  props: {
    flowAction: {
      type: String,
      default: ECollectionFlowActions.NONE,
      validator: (value: string) => {
        return Object.values(ECollectionFlowActions).includes(value)
      }
    },
    disabledActionNames: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultTimeframe: {
      type: Number,
      default: 10
    },
    actions: {
      type: Array,
      required: true
    },
    default: {
      type: Boolean
    },
    index: {
      type: Number
    },
    id: {
      type: String
    }
  },
  components: {
    InputV2,
    Icon,
    AccordionSelect
  }
})
export default class FlowItem extends Vue {
  items: IFlowItem[] = []
  timeframe: number = 0
  ECollectionFlowActions: any = ECollectionFlowActions
  ETemplateType: any = ETemplateType

  get facilityId () {
    return this.$route.params.id
  }

  get templateList () {
    return this.$store.state.template.templates
  }

  get letterTemplates () {
    return this.templateList.filter((template: ITemplate) => (
      template.type === ETemplateType.LETTER
    ))
  }

  get messageTemplates () {
    return this.templateList.filter((template: ITemplate) => (
      template.type === ETemplateType.MESSAGE
    ))
  }

  get letterTemplatesItemList () {
    return this.letterTemplates.map((template: ITemplate) => ({
      key: template.id,
      value: template.id,
      content: template.templateName
    }))
  }

  get messageTemplatesItemList () {
    return this.messageTemplates.map((template: ITemplate) => ({
      key: template.id,
      value: template.id,
      content: template.templateName
    }))
  }

  get writeOffItemList () {
    return [{
      content: 'Write Off Only',
      key: 'write-off',
      value: 'write-off'
    }, {
      content: 'Write Off And Cease Collections',
      key: 'write-off-and-cease-collections',
      value: 'write-off-and-cease-collections'
    }]
  }

  get collectionsItemList () {
    return [{
      content: 'Add to Collections',
      key: 'Add to Collections',
      value: 'add-to-collection'
    }]
  }

  get flowActionLabel () {
    const FLOW_ACTION_LABEL_MAP: { [k: string]: string } = {
      [ECollectionFlowActions.CHANGE_STATUS_TO_DUE]: 'Change Status To Due',
      [ECollectionFlowActions.CHANGE_STATUS_TO_OVERDUE]: 'Change Status To Overdue',
      [ECollectionFlowActions.CHANGE_STATUS_TO_DELINQUENT]: 'Change Status To Delinquent'
    }
    return FLOW_ACTION_LABEL_MAP[this.$props.flowAction]
  }

  mounted () {
    this.timeframe = this.$props.defaultTimeframe
    this.items = this.$props.actions.slice()
  }

  updated () {
    this.items = this.$props.actions
  }

  addItem () {
    this.items.push({ template: null })
  }

  removeItem (itemIndex: number) {
    this.items.splice(itemIndex, 1)
    this.emitChange()
  }

  handleAddNewTemplate (type: ETemplateType) {
    return () => {
      this.$emit('createTemplate', {
        type
      })
    }
  }

  selectFlowItem (flowItem: IFlowItem, selectItem: ISelectItem) {
    flowItem.template = selectItem.value
    this.emitChange()
  }

  changeTimerame (value: string) {
    this.timeframe = parseInt(value, 10)
    this.emitChange(true)
  }

  emitChange (silent: boolean = false) {
    this.$emit('change', {
      silent: silent,
      actions: this.items,
      timeframe: this.timeframe,
      flowAction: this.$props.flowAction,
      id: this.$props.id
    })
  }
}
